import _ from 'lodash';
import * as parse5 from 'parse5';
import { generateBbsCode } from './generate';
import { translateTree } from './translate';
import { isElement, isParentNode, isTextNode } from './utils';

function getArticleTreeTraverse(tree) {
  if (tree.nodeName === 'article') {
    return tree;
  }

  if (tree.nodeName === 'blockquote') {
    return tree;
  }

  if (isElement(tree)) {
    var classAttr = tree.attrs.find(function (v) {
      return v.name === 'class';
    });

    if (classAttr && classAttr.value.includes('notes-detail')) {
      return tree;
    }

    if (classAttr && classAttr.value.includes('news_area')) {
      return tree;
    }

    if (classAttr && classAttr.value.includes('article-container')) {
      return tree;
    }

    var idAttr = tree.attrs.find(function (v) {
      return v.name === 'id';
    });

    if (idAttr && idAttr.value === 'mainNews') {
      return tree;
    }
  }

  if (!isParentNode(tree)) {
    return undefined;
  }

  var result;

  _.forEach(tree.childNodes, function (node) {
    if (node) {
      var found = getArticleTreeTraverse(node);

      if (found) {
        result = found;
        return false; // break
      }
    }
  });

  return result;
}

function getArticleTree(htmlText) {
  var htmlTree = parse5.parse(htmlText);
  var articleTree = getArticleTreeTraverse(htmlTree);

  if (!articleTree) {
    throw new Error('Can\'t find the article.');
  }

  return articleTree;
}

export function standardizeTree(node) {
  if (isTextNode(node)) {
    return {
      kind: 'text',
      text: node.value
    };
  }

  return {
    kind: 'parent',
    tag: node.nodeName,
    children: isParentNode(node) ? node.childNodes.map(standardizeTree) : [],
    attrs: isElement(node) ? node.attrs : []
  };
}

function transformNgaNode(tree) {
  return generateBbsCode(tree);
}

export function pageToBbsCode(_a, _b) {
  var htmlText = _a.htmlText,
      url = _a.url;
  var doTranslate = _b.doTranslate;
  var tree = standardizeTree(getArticleTree(htmlText));
  var translatedTree = doTranslate ? translateTree(tree) : tree;
  var sourceStr = url ? "[quote]\u82F1\u6587\u65E5\u5FD7\uFF1A" + url + "\n[/quote]\n" : '';
  return "[quote]\u8F6C\u8F7D\u8BF7\u6CE8\u660E\u672C\u5E16\u6765\u6E90NGA[s:a2:poi]\n[/quote]\n" + sourceStr + transformNgaNode(translatedTree);
}